
/**
 * Esegue un download di un file dato un url accessibile
 */
// export async function downloadUrl(url: string, fileName?: string) {
// 	if (!url) return;
// 	try {
// 		// Fetch dell'immagine
// 		const response = await fetch(url);
// 		if (!response.ok) throw new Error('Failed to fetch image');
// 		// Converte la risposta in blob
// 		const blob = await response.blob();
// 		if (!fileName) {
// 			const urlParts = url.split('/');
// 			fileName = urlParts[urlParts.length - 1] || 'photo.jpg';
// 		}
// 		downloadBlob(blob, fileName);

// 	} catch (error) {
// 		console.error('Error downloading image:', error);
// 	}
// }

export function downloadBlob(blob: Blob, fileName: string) {
	// Crea un URL temporaneo per il blob
	const blobUrl = window.URL.createObjectURL(blob);
	// Crea un elemento <a> temporaneo per il download
	const link = document.createElement('a');
	link.href = blobUrl;
	// Estrae il nome del file dall'URL o usa un nome di default

	link.download = fileName;
	// Aggiunge il link al DOM, clicca e rimuove
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	// Pulisce l'URL temporaneo
	window.URL.revokeObjectURL(blobUrl);
}
